module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_270deg.e6d80a46.png";